<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Exodus
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To show that the Exodus sets the pattern for how God rescues his people.
                        </li>
                        <li>
                            To teach the nature of sin as it is illustrated in the life of Pharaoh.
                        </li>
                        <li>
                            To show how the Passover lamb is a picture of Jesus' death in our place.
                        </li>
                        <li>
                            To understand that trials and difficulties serve to increase our trust in God.
                        </li>
                        <li>
                            To teach that obedience is a response to God's gracious rescue, not what effects the rescue.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series traces the amazing story of how God rescued his people from slavery in Egypt
                        in order that he might be with them. The series begins with the miraculous rescue of a
                        baby who would grow up to be the leader of God's people and ends with the entire nation
                        of Israel assembled at Mount Sinai in Exodus 19.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - God Grows His People (Exodus 1:1 - 2:10)
                    </p>
                    <p>
                        Lesson 2 - God Reveals Himself (Exodus 3:1 - 4:17)
                    </p>
                    <p>
                        Lesson 3 - God Shows His Power to Judge (Exodus 5:1 - 10:29)
                    </p>
                    <p>
                        Lesson 4 - God Delivers His People (Exodus 11:1 - 12:42)
                    </p>
                    <p>
                        Lesson 5 - God Destroys His Enemies (Exodus 13:17 - 14:31)
                    </p>
                    <p>
                        Lesson 6 - God Feeds His People (Exodus 16:1-36)
                    </p>
                    <p>
                        Lesson 7 - God Tests His People (Exodus 17:1-16)
                    </p>
                    <p>
                        Lesson 8 - God Teaches His People (Exodus 19:1 - 20:21)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Exodus",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Exodus`,
            meta: [
                {
                    name: 'description',
                    content: "To show that the Exodus sets the pattern for how God rescues his people.",
                },
            ],
        };
    },
};
</script>
